import React, {PureComponent} from 'react';
import {Helmet} from 'react-helmet';
import {toastr} from 'react-redux-toastr';
import connect from 'react-redux/es/connect/connect';

import DefaultLayout from '../Layout/DefaultLayout.jsx';
import DropNeedForm from '../../components/Forms/DropNeedForm/DropNeedForm.jsx';
import Header from '../../components/Header/Header.jsx';
import Loader from '../../../shared/components/Loader/Loader.jsx';
import SubmitButton from '../../components/Forms/DropNeedForm/SubmitButton.jsx';
import UploadDropZone from '../../components/Form/Field/UploadDropZone.jsx';

import api from '../../../api.js';
import conf from '../../conf.js';
import {handleResponseErrors} from '../../services/processServerErrors.js';

const title = 'Trouvez votre expert des fonctions corporate';
const description = 'Déposez votre besoin : nos managers sélectionnent pour vous les profils les plus pertinents ' +
  'pour répondre à vos enjeux et attentes';

class DropNeed extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      uploading: false,
      errors: null,
      fileId: null,
      filename: null,
    };
  }

  onFileSubmit = async (data) => {
    this.setState({uploading: true, errors: null});

    try {
      const dataResponse = (await api.dropneeds.upload(data).catch(handleResponseErrors)).data;
      this.setState({
        uploading: false,
        filename: dataResponse.name,
        fileId: dataResponse.id
      });
      return dataResponse;
    } catch (e) {
      console.warn(e);
      this.setState({uploading: false, errors: e.errors});
    }
  };

  submit = async (data) => {
    try {
      const body = {
        ...data,
        file: this.state.fileId,
      };

      return (await api.dropneeds.post(body));
    } catch (e) {
      toastr.error(`Nous n'avons pas pu recevoir vos éléments, veuillez nous contacter au ${conf.site.phone}`, {timeOut: 0});
      console.warn(e);
    }
  };

  onFormSuccess = (response) => {
    toastr.success(response.data.message);
  };

  render() {
    const helmet = <Helmet>
      <title>{title}</title>
      <meta name="description" content={description}/>
      <meta property="og:description" content={description}/>
      <meta property="og:title" content={title}/>
    </Helmet>;

    const headerBrief = <p>Notre équipe recherche pour vous les profils les plus adaptés à votre besoin</p>;

    return (
      <DefaultLayout helmet={helmet} showSidebarMenu={true}>
        <Header brief={headerBrief} title="Proposer une mission dans mon équipe"/>

        <section className="container pb-5">
          <DropNeedForm
            initialValues={{
              lastname: this.props?.user?.lastname ?? '',
              email: this.props?.user?.email ?? '',
              tel: this.props?.user?.tel ?? '',
              company: this.props?.user?.organization?.name ?? '',
              universe: this.props?.currentUniverseId
            }}
            onSubmit={this.submit}
            onSubmitSuccess={this.onFormSuccess}
          />
          <div className="row mb-4">
            <div className="col-md-12">
              <UploadDropZone
                className="dropzone"
                input={{value: this.state.fileId, name: 'uploadedFile'}}
                dropText="Déposer mon appel d'offre en Drag'n'Drop"
                uploadText="Sélectionner mon appel d'offre"
                uploadModifyText="Modifier mon appel d'offre"
                onSubmit={this.onFileSubmit}
                maxSize={conf.server.uploadMaxSize}
                acceptText=".doc, .docx, .pdf"
                accept={conf.allowedMimeTypes.dropneed}>
                {this.state.filename && <span>Le fichier {this.state.filename} a bien été téléchargé</span>}
              </UploadDropZone>
              <Loader visible={this.state.uploading}>
                Upload en cours...
              </Loader>
            </div>
          </div>
          <div className="row mt-1">
            <div className="col-md-12 text-center">
              <SubmitButton className="btn btn-primary ml-auto">Envoyer</SubmitButton>
            </div>
          </div>
        </section>
      </DefaultLayout>
    )
  }
}

export default connect(
  state => ({
    user: state.currentUser.user,
    loading: state.currentUser.loading,
    currentUniverseId: state?.universe?.currentUniverse?.id ?? state?.universe?.universes?.[0]?.id
  }),
)(DropNeed);
